import { getValueAtPath, withProperties, isPlainObject } from "../../../../utils";
import withReactiveFields from "../../helpers/reactivefields";
import { USES_ORDER_REFERENCE } from "../../../../charge/flags";
import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";
import ErrorState from "../../../common/error";
import InitView from "./views/init";
import CodeView from "./views/code";
import { CHECKOUT_CLOSE_EVENT, SWITCH_METHOD_EVENT } from "../../../helpers/tokens";
import { falseFunction } from "../../../../collections/helpers";
import Fetcher from "../../../../fetcher"
import { DEFAULT_POST_INIT, isJsonResponse, withSharedHeaders } from "../../../../fetcher/utils";
import { traverseDataFields } from "../../../../charge/handler/helpers";
import withCountdownTimer from "../../helpers/countdowntimer";
import PendingView from "../../common/pending";

const $fetcher = withSharedHeaders(Fetcher.many.init(DEFAULT_POST_INIT));
const $endpoint = new URL('/v2/nqr/cancel', process.env.API_BASE_URL)

const METHOD = 'nqr';
const METHOD_NAME = 'NQR';
const CHARGE_MODE = USES_ORDER_REFERENCE;

const VIEWS = [ InitView, CodeView ];

function mount() {
  return (dispatch) => {
    // Some logic here to determine the view to show instead of
    // always showing the bank (first) view, nd also other stuffs
    // like fee check, limit check, etc.
    getChargeLimit.call(this, () => {
      const VIEW = (
        this.QR_CODE && (CodeView || (this.QR_CODE = null))
      ) || InitView;

      VIEW && VIEW.activate(() => this.startListeningForCancellation());
    });

    getChargeFee();
  };
}

function getChargeData() {
  return ({
    is_nqr: true,
    payment_type: 'nibss-qr'
  });
}

function getViewsContext(data, store) {
  const TIMER_DURATION = 5 * 60;
  const REACTIVE_FIELDS = ['QR_CODE', 'CURRENT_TIME'];
  const $context = withReactiveFields(Object.create(null), ...REACTIVE_FIELDS);
  let listening = false;

  const cancellationListener = () => {
    stopListeningForCancellation();
    cancelNQR();
  }

  const startListeningForCancellation = () => {
    if (listening !== true) {
      addEventListener(SWITCH_METHOD_EVENT, cancellationListener, false);
      addEventListener(CHECKOUT_CLOSE_EVENT, cancellationListener, false);

      listening = true;
    }
  }

  const stopListeningForCancellation = () => {
    if (listening === true) {
      removeEventListener(SWITCH_METHOD_EVENT, cancellationListener, false);
      removeEventListener(CHECKOUT_CLOSE_EVENT, cancellationListener, false);

      listening = false
    }
  }

  const cancelNQR = () => {
    if (getValueAtPath($context.STATE, "view.current") === "NQR_CODE_VIEW") {
      const public_key = getValueAtPath(data, "PBFPubKey")
      const {
        charge: reference = null
      } = isPlainObject($context.reference) ? $context.reference : {};
  
      const payload = JSON.stringify({ public_key, reference });
      return $fetcher($endpoint, { body: payload })
        .then(response => {
          if (isJsonResponse(response)) {
            return response.json()
              .then(response => {
                if (response.status === 'success') {
                  // const { response_code } = traverseDataFields(response.data, 'response_code');
                  // if (response_code === '18') {
                  //   const { response_message } = traverseDataFields(response.data, 'response_message');
                    // setTimeout(() => $context.dispatch(
                    //   ErrorState.actions.updateErrorMessage(response_message)
                    // ), 100)
                    
                    // Reset context so there's no QR Code to load on return to the payment method
                    $context.$resetContext();
                  // }
                }
              })
          } else {
            return Promise.reject();
          }
        })
        .catch(falseFunction);
    }
  }

  $context.$subscribe('QR_CODE', (currentValue, oldValue) => {
    setTimeout(() => {
      if (!oldValue && currentValue && oldValue !== currentValue) {
        CodeView && CodeView.activate();
      }
    }, 0);
  });

  withProperties($context, {
    TIMER_DURATION,
    $resetContext() {
      $context.QR_CODE = null;
    },

    startListeningForCancellation,
    stopListeningForCancellation,
    INIT_VIEW: callback => {
      InitView && InitView.activate(callback);
    }
  });

  return withCountdownTimer($context, {
    duration: TIMER_DURATION,
    onTick() { $context.CURRENT_TIME = $context.$timer.current },
    onFinish() {
      if ($context.$charge.cancel()) {
        $context.$timer && $context.$timer.clear();
        $context.CURRENT_TIME = null;
        $context.$resetContext();
        stopListeningForCancellation()
        setTimeout(() => {
          ErrorState.actions.updateErrorMessage('');
          PendingView && PendingView.activate.call($context);
        }, 10)
      }
    }
  })
}

export {
  METHOD,
  METHOD_NAME,
  CHARGE_MODE,
  VIEWS,
  mount,
  getChargeData,
  getViewsContext
}
